import { render, staticRenderFns } from "./CadastrarVagas.vue?vue&type=template&id=202d034e"
import script from "./CadastrarVagas.vue?vue&type=script&lang=js"
export * from "./CadastrarVagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports